import { FC } from "react";
import { Avatar, Button, Select } from "antd";
import {
  grayPointSVG,
  greenServiceSVG,
  trashSVG,
} from "../../../assets/SVGs/SVGs";

import { availableTeamMember } from "../../../types/calendar";
import { UserOutlined } from "@ant-design/icons";
import { selectedPackages } from "../../../types/package";
import { useIntl } from "react-intl";

interface PackageWithTeamMemberSelectProps {
  packageItem: selectedPackages;
  teamMembers: availableTeamMember[];
  manualSelect: boolean;
  handleRemovePackage: (id: number) => void;
  handleSelectTeamMember: (
    id: number,
    teamMember: {
      id: number;
      name: string;
      media: string;
    },
    type: "service" | "package"
  ) => void;
  isLoading: boolean;
}

const PackageWithTeamMemberSelect: FC<PackageWithTeamMemberSelectProps> = ({
  packageItem,
  teamMembers,
  manualSelect,
  handleRemovePackage,
  handleSelectTeamMember,
  isLoading,
}) => {
  const intl = useIntl();
  const findTeamMember = (id: number) => {
    const teamMember = teamMembers?.find(
      (member: availableTeamMember) => member?.id === id
    );

    return teamMember;
  };
  const getTeamMembersOptions = (id: number, type: "service" | "package") => {
    if (!teamMembers?.length) {
      return [];
    }
    const filteredTeamMembers = teamMembers?.filter(
      (member: availableTeamMember) =>
        (type === "service" && member?.service_id?.includes(id)) ||
        (type === "package" && member?.package_id?.includes(id))
    );
    const temMembersOptions =
      filteredTeamMembers?.map((option: availableTeamMember) => {
        return {
          label: (
            <div className="flex items-center justify-between gap-2 px-2 ">
              <div className="flex gap-2 items-center w-full">
                <Avatar
                  size={30}
                  src={option?.media}
                  className="bg-salon-primary-light"
                  icon={<UserOutlined />}
                >
                  {option?.name?.charAt(0)}
                </Avatar>
                <p className=" capitalize">{option?.name}</p>
              </div>
            </div>
          ),
          key: String(option?.id),
          value: String(option?.id),
        };
      }) || [];

    return temMembersOptions;
  };
  return (
    <div className="bg-[#fbfbfb] rounded-md my-2 p-4 space-x-6">
      <div className="flex justify-between items-center gap-2 text-salon-primary">
        <p className="flex gap-2 items-center">
          <span>{greenServiceSVG}</span>
          <span className="capitalize">{packageItem.name}</span>
        </p>
        <span>{grayPointSVG}</span>
        <p className="flex gap-2 items-center">
          <span>{packageItem.total_time}</span>
          <small className="text-xs">
            {intl.formatMessage({ id: "mins" })}
          </small>
        </p>
        <span>{grayPointSVG}</span>
        <p className="flex gap-2 items-center">
          <span>{packageItem.retail_price}</span>
          <small className="text-xs">{intl.formatMessage({ id: "SAR" })}</small>
        </p>
        <Button
          type="link"
          htmlType="button"
          onClick={() => handleRemovePackage(packageItem.id)}
        >
          {trashSVG}
        </Button>
      </div>
      <div className="rounded-select">
        <Select
          notFoundContent={
            <p className="text-red-700 p-2 font-semibold text-center">
              {intl.formatMessage({ id: "selectTeamMemberWarningTextPackage" })}
            </p>
          }
          loading={isLoading}
          disabled={!manualSelect}
          onChange={(id) => {
            const teamMember = findTeamMember(+id);
            if (!teamMember) return;
            handleSelectTeamMember(packageItem.id, teamMember, "package");
          }}
          value={String(packageItem?.teamMember?.id || "")}
          className="ms-2  w-full rounded-full !bg-[#EEF0FF] h-12 "
          options={getTeamMembersOptions(packageItem?.id, "package")}
        />
      </div>
    </div>
  );
};

export default PackageWithTeamMemberSelect;
